import { HttpService } from '@/shared/api/services/HttpService';
import { buildUrlForServiceName } from '@/connection/url-retriever';
import conf from '@/shared/config/useConfig';
import type {
  Kommunikation,
  Gevo,
  BuergeKommunikationBulkResult,
} from '@/shared/AvalKonfigurator/Kommunikation';
import type { Avalart } from '@/shared/Avalarten/types.ts';

export class SharedAvalPartnerKonfiguratorService extends HttpService {
  protected avalPartnerKonfiguratorServiceBaseUrl = `${buildUrlForServiceName(
    conf.avalpartnerkonfiguratorName,
  )}/api/private/v1`;

  async holeBuergenKommunikation(gevo: Gevo, buergeId: string): Promise<Kommunikation> {
    return this.httpClient.get(
      `${this.avalPartnerKonfiguratorServiceBaseUrl}/buerge/${buergeId}/gevo/${gevo}`,
    );
  }

  async holeBuergenKommunikationBulk(
    buergeIds: string[],
  ): Promise<Record<string, BuergeKommunikationBulkResult>> {
    return this.httpClient.post(`${this.avalPartnerKonfiguratorServiceBaseUrl}/buerge/gevo/bulk`, {
      data: buergeIds,
    });
  }

  async holeAuftraggeberKommunikation(gevo: Gevo, unternehmenId: string): Promise<Kommunikation> {
    return this.httpClient.get(
      `${this.avalPartnerKonfiguratorServiceBaseUrl}/auftraggeber/${unternehmenId}/gevo/${gevo}`,
    );
  }

  async findeAlleAvalarten(params?: {
    locale?: string;
    manuellerImport?: boolean;
  }): Promise<Avalart[]> {
    return this.httpClient.get(`${this.avalPartnerKonfiguratorServiceBaseUrl}/avalarten`, {
      params,
    });
  }
}
